import React from 'react';
import { useLineLoginGuard } from '../../hooks/useLineLoginGuard';
import { LoadingSpinner, ErrorMessage, LineOpenPrompt } from '../../components';
import LinkToken from './components/LinkToken';

export const LinkTokenPage: React.FC = () => {
  const { isChecking, isLineLoggedIn, liffError } = useLineLoginGuard();

  if (isChecking) {
    return <LoadingSpinner fullPage message="認証確認中..." />;
  }

  if (liffError) {
    return (
      <ErrorMessage
        fullPage
        title="初期化エラー"
        description={liffError}
        onRetry={() => window.location.reload()}
        retryLabel="再読み込み"
      />
    );
  }

  if (!isLineLoggedIn) {
    const liffUrl = `https://liff.line.me/${import.meta.env.VITE_LIFF_ID}${window.location.pathname}${window.location.search}`;
    const userAgent = navigator.userAgent || '';
    const lineInstallUrl = /android/i.test(userAgent)
      ? 'https://play.google.com/store/apps/details?id=jp.naver.line.android'
      : /iPhone|iPad|iPod/i.test(userAgent)
        ? 'https://apps.apple.com/jp/app/line/id443904275'
        : 'https://line.me/ja/download';

    return <LineOpenPrompt liffUrl={liffUrl} lineInstallUrl={lineInstallUrl} />;
  }

  return <LinkToken />;
};

export default LinkTokenPage;
